<template>
    <div class="page-wrapper">
    <CustomHeader :text="$t('activityName.daily_first_recharge')" :is-popup-close-back-icon="true"
        @close-popup="backNavigate" />
    <div class="bannerContainer">
        <img :src="dataSet.bannerIcon" alt="">
    </div>
    <div class="recharge_content">
        <div class="recharge_container">
            <div class="subContainer">
                <div class="day_num" v-for="(item, index) in dataSet.configList" :key="index" @click="selectTab(item)">
                    <div class="numberText" :style="{
                        backgroundImage: dataSet.selectedTabData?.day === item?.day
                            ? `url(${require('@/assets/themeFour/TabAfterT4.png')})`
                            : `url(${require('@/assets/themeFour/TabBeforeT4.png')})`,
                        opacity: dataSet.selectedTabData?.day === item?.day ? 2 : 1
                    }" :class="dataSet.selectedTabData?.day === item?.day ? 'activeNumText' : ''">{{ item?.day }}</div>
                    <div class="selectIcon">
                        <img v-if="dataSet.selectedTabData?.day === item?.day" src="@/assets/themeFour/arrow4.png"
                            alt="">
                        <div v-else style="padding-bottom:15px ;"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="detailsCard">
            <van-row class="cardTitle">
                <van-col span="2" class="titleImage">
                    <img src="@/assets/firstRecharge/frch_title_icon.png" alt="">
                </van-col>
                <van-col span="20" style="padding-left:5px;">{{ $t('activity.firstDepositTitle') }}</van-col>
                <van-col span="24" class="textImage">
                    <img v-if="dataSet.selectedTabData?.activeStatus === 1 && dataSet.isRewardEligible"
                        src="@/assets/firstRecharge/frch_sttaus_notstart.png" alt="">
                    <img v-else src="@/assets/firstRecharge/frch_status_unactivated.png" alt="">
                </van-col>
            </van-row>
            <div class="tableContainer">
                <van-row class="tableHead">
                    <van-col span="12" class="tableTitle">{{
                        $t('activity.depositAmount') }}</van-col>
                    <van-col span="12" class="tableTitle">{{ $t('activity.additionalBonus') }}</van-col>
                </van-row>
                <div style="padding: 0 5px;" v-for="(item, i) in dataSet.selectedTabData?.recharge_config" :key="i">
                    <van-row class="tabelRaws">
                        <van-col span="12" class="tableTitle tabelValue1">
                            <div class="rs-icon">R$</div>
                            <span>{{ formatCurrency(item?.credits) }}</span>
                        </van-col>
                        <van-col span="12" class="tableTitle tabelValue2">
                            <div class="rs-icon">R$</div>
                            <span>{{ formatCurrency(item?.credits) }}</span>
                        </van-col>
                    </van-row>
                </div>
            </div>
        </div>
    </div>
    <div class="bottom_text" v-if="dataSet.activityInfo?.length > 0">
        <van-row style="padding-bottom: 10px;">
                <van-col span="24" class="title">
                    <div class="ruleHeader">
                        <img class="side-icon" src="@/assets/themeFour/tittleIcon.png" />
                        <div class="title">{{ $t('common.activityTitle') }}</div>
                        <img class="side-icon flipped" src="@/assets/themeFour/tittleIcon.png" />
                    </div>
                </van-col>
            </van-row>
        <div class="detailsCardText" style="padding-top: 15px;">
            <div class="line_text" v-for="(item, index) in dataSet.activityInfo" :key="index">
                {{ item }}
            </div>
        </div>
    </div>
  
    <div class="footerActionContainer">
        <div class="statusButton" v-if="dataSet.selectedTabData?.record">
            <p v-if="setActivityStatus() == 0" style="color: #0484ff;">{{ $t('activityStatus.pending') }}</p>
            <p v-else-if="setActivityStatus() == 1" style="color: #36d836;">{{ $t('activityStatus.completed') }}</p>
            <p v-else-if="setActivityStatus() == 2" style="color: #ff0000;">{{ $t('activityStatus.noRewards') }}</p>
            <p v-else style="color: #ff0000;">{{ $t('activity.overdue') }}</p>
        </div>
        <div v-else
            :class="dataSet.selectedTabData?.activeStatus === 1 && dataSet.isRewardEligible ? 'depositBtn' : 'deposit-disabled'"
            @click="goToDeposit">
            {{ $t('activity.immediateDeposit') }}
        </div>
    </div>
</div>

</template>
<script setup lang="ts">
import CustomHeader from '../components/common/customHeader.vue';
import { } from 'vue';
import { FirstDepositData } from '@/view/firstDeposit/newFirstRecharge';
import { useUserStore } from '@/stores/user';
import { useRouter } from 'vue-router';
import { formatCurrency } from '@/utils/commonFunction';
const userStore = useUserStore()
const router = useRouter()
const props = defineProps<{
    dataSet: FirstDepositData
}>()
const emits = defineEmits(['goToDeposit', 'selectTab'])

const goToDeposit = () => {
    emits("goToDeposit")
    localStorage.setItem('showDepositBackIcon', '1')
}

const setActivityStatus = () => {
    return props.dataSet.selectedTabData.record?.status
}

const selectTab = (item: any) => {
    emits("selectTab", item)
}

const backNavigate = () => {
    userStore.setTakeFirstDeposit(false)
    router.replace({ path: '/home', query: {} })
}
</script>
<style scoped>

.line_text {
    border-color: #00615f;
}

.page-wrapper {
    background-color:  rgb(1, 53, 52);
    /* min-height: 100vh; */
}

.bannerContainer img {
    width: 100%;
}

.bannerContainer {
    padding-top: 50px;
}

.recharge_content {
    padding: 0 25px;
}

.recharge_container {
    background-image: linear-gradient(to bottom, rgb(3, 97, 95), rgb(1, 35, 34));
    padding: 10px 15px 0;
    border-radius: 15px;

}

.recharge_container::-webkit-scrollbar {
    display: none;
}

.subContainer {
    max-width: 100%;
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.day_num {
    position: relative;
    flex: 0 0 auto;
    justify-content: center;
    width: 20%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.day_num img {
    width: 100%;
}

.numberText {
    color: rgb(3, 124, 122);
    font-size: 18px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: cover;
    background-repeat: repeat;
    width: 55px;
    height: 55px;
}

.activeNumText {
    color: rgb(1, 53, 52);
}

.selectIcon {
    display: flex;
    justify-content: center;
}

.selectIcon img {
    height: 15px;
    width: 20px;
}

.detailsCard {
    background-color: rgb(1, 53, 52);
    border-radius: 15px;
    margin: 0 auto;
    box-sizing: border-box;
    overflow: hidden;
    padding: 0 15px 15px;
    box-shadow: 0px 0px 10px rgb(2, 74, 73);
}

.cardTitle {
    display: flex;
    align-items: center;
    color: #0db0ae;
    font-size: 18px;
    padding: 10px 0;
}

.titleImage img {
    width: 85%;
}

.textImage img {
    width: 100%;
}

.tableContainer {
    background-color:  rgb(1, 53, 52);
    padding: 20px;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    gap: 12px;

}

.tableHead {
    display: flex;
    width: 100%;
    padding: 10px 0;
    margin-bottom: 5px;
    align-items: flex-start;
}

.tableTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    color: #a9d3ff;
    font-size: 14px;
    line-height: 1.4;
    padding: 0 5px;
    word-break: break-word;
    height: auto;
    min-height: 34px;
}

.tabelRaws {
    display: flex;
    align-items: center;
    color: #FFFFFF;
    background-color: #005655;
    border-radius: 10px;
    padding: 10px 0;
    border-color: #00615f;
    border-style: solid;
    border-width: 0.125rem;

    
}

.tableTitle {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #ffffff;
    font-size: 16px;
    line-height: 1.2;
    padding: 0 5px;
    word-break: break-word;
    min-height: 38px;
    flex: 1;
}

.tabelValue1,
.tabelValue2 {
    padding: 0 !important;
}

.tabelValue1 span {
    font-weight: bold;
    color: #fff;
    font-size: 16px;
    padding: 0 10px;
}

.tabelValue2 span {
    font-weight: bold;
    color: #fc974c;
    font-size: 16px;
    padding: 0 10px;
}



.depositBtnContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 10px;
}

.statusButton {
    font-weight: 600;
    background-color: rgb(0, 20, 20);
    padding: 10px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 30px;
    cursor: pointer;
    position: center;
    border-radius: 5px;             

}

.depositBtn {
    color: #ffffff;;
    font-weight: 600;
    background: linear-gradient(90deg,  #f5c55b 0%,  #dd7a33 74.8%);
    padding: 10px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 30px;
    cursor: pointer;
    position: center;
    border-radius: 5px;
}

.bottom_text {
    padding: 24px;
    max-width: 500px;
    margin: 16px  0 0;
    background-color: transparent;
    padding-bottom: 120px !important;
}

.footerActionContainer {
    position: fixed;
    bottom: 0;           
    transform: none;    
    width: 100%;        
    z-index: 999;
    background: rgb(2, 74, 73) !important; 
    padding: 10px 15px;  
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.deposit-disabled {
    background: rgba(255, 255, 255, 0.05);
    color: rgba(255, 255, 255, 0.2);
    width: 100%;
    height: 48px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    font-size: 16px;
}

.title-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 12px;
    padding: 20px 0;
    margin: 0 auto;
}

.title {
    color: #ffffff;
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    white-space: nowrap;
    padding: 10px;
}

.line_text {
    color: #ffffff99;
    font-size: 18px;
    padding: 10px;
    line-height: 1.5;
}

.rs-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: radial-gradient(circle, #8792ce 10%, #8aaafb 80%);
    border: 2.5px solid #e5e7eb;
    color: #fff;
    font-size: 10px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
    flex-shrink: 0;
}


.ruleHeader {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 10px;
    position: relative;
    z-index: 10;
}

.side-icon {
    width: 45px;
    height: auto;
    display: block;
}

.flipped {
    transform: scaleX(-1);
}

.title {
    color: #ffffff;
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    white-space: nowrap;
}

.detailsCardText{
    background-color: #012121;
    border-radius: 15px;
    margin: 0 auto;
    box-sizing: border-box;
    overflow: hidden;
    padding: 0 15px 15px;
}


@media(min-width: 450px) {
    .numberText {
        width: 65px;
        height: 65px;
    }
}

@media(min-width: 360px) {
    .statusButton {
        width: 80%;
    }

    .tabelRaws {
        padding: 5px 0px;
    }


}

@media screen and (min-width: 768px) {
    .line_text {
        font-size: 18px;
    }

    .statusButton {
        font-size: 18px !important;
    }

    .depositBtn {
        font-size: 18px !important;
    }

    .bottom_text{
        padding: 25px;
    
    }


}

@media screen and (max-width: 360px) {
    .line_text {
        font-size: 14px;
        padding: 8px;
    }

    .side-icon {
        width: 30px;
    }

    .title {
        font-size: 16px;
    }

    .statusButton{
        height: 25px;
        font-size: 14px !important;
    }

    .cardTitle {
        font-size: 14px;
    }   

    .depositBtn {
        font-size: 14px !important;
    }

    .tabelRaws{
        padding: 0px 0px; 
    }

    .rs-icon{
        width: 16px;
        height: 16px;
        font-size: 8px;
    }
    .tabelValue1 span, .tabelValue2 span {
        font-size: 13px;
    }

    .deposit-disabled{
        font-size: 14px;
    
    }

    .tableTitle{
        font-size: 12px;
    }
}
</style>